import { render, staticRenderFns } from "./AllMessages.vue?vue&type=template&id=0bbd626c&scoped=true"
import script from "./AllMessages.vue?vue&type=script&lang=js"
export * from "./AllMessages.vue?vue&type=script&lang=js"
import style0 from "./AllMessages.vue?vue&type=style&index=0&id=0bbd626c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbd626c",
  null
  
)

export default component.exports